import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
// 按需引入iepge组件样式
import { isMobile } from '@/utils/userAgentUtil.js'

import clip from '@/components/CompClip/index.vue'

import {
  Popconfirm,
  Button,
  Row,
  Col,
  Form,
  Input,
  InputNumber,
  Checkbox,
  Icon,
  message,
  Menu,
  Modal,
  Table,
  Spin,
  Tabs,
  Select,
  Pagination,
  Dropdown,
  DatePicker,
  Tooltip,
  Upload,
  Radio,
  Progress,
  Cascader,
  Divider,
  Alert,
  Drawer,
  Empty,
  Tag,
  Descriptions,
  // TimePicker,
  FormModel,
  Popover,
  Collapse,
  ConfigProvider,
  Switch
  // Carousel,
  // Calendar,
  // List,
  // Avatar
} from 'ant-design-vue'
import { mixin } from '@/utils/common.js'
import global_fun from '@/utils/global_fun'
import debounce from 'lodash/debounce'
import throttle from 'lodash/throttle'
import VueDOMPurifyHTML from 'vue-dompurify-html'

Vue.use(VueDOMPurifyHTML)
Vue.component('clip', clip)
// Vue.component('v-chart', ECharts)

// Vue.use(VueAMap)
Vue.mixin(mixin)
Vue.use(global_fun)
// VueAMap.initAMapApiLoader({
//   key: process.env.VUE_APP_MAP_KEY,
//   plugin: [
//     'AMap.PlaceSearch',
//     'AMap.Scale',
//     'AMap.OverView',
//     'AMap.ToolBar',
//     'AMap.MapType',
//     'Geocoder',
//     'AMap.Geolocation'
//   ],
//   v: '1.4.4'
// })

// 后端增删改 新增的 3s两次的延迟
Vue.prototype.$apiDelay = 3000
Vue.prototype.$message = message
message.config({
  top: '100px',
  duration: 4,
  maxCount: 1
})
Vue.prototype.$confirm = Modal.confirm
Vue.prototype.$info = Modal.info
Vue.prototype.$warning = Modal.warning
// process.env.NODE_ENV === 'development'
Vue.prototype.$isInt =
  process.env.NODE_ENV === 'international' || process.env.NODE_ENV === 'preInt'

Vue.prototype.$isPro =
  process.env.NODE_ENV === 'production' || process.env.NODE_ENV === 'pre'
// 添加全局防抖
Vue.directive('debounce-click', {
  bind(el, binding) {
    const debounceTime = binding.arg || 300
    const originalHandler = binding.value.handler || binding.value

    el.addEventListener(
      'click',
      debounce(originalHandler, debounceTime, {
        leading: true,
        trailing: false
      })
    )
  },
  unbind(el, binding) {
    const debounceTime = binding.arg || 300
    const originalHandler = binding.value.handler || binding.value

    el.removeEventListener('click', debounce(originalHandler, debounceTime))
  }
})
Vue.directive('throttle-click', {
  bind(el, binding) {
    const throttleTime = binding.arg || 300
    const originalHandler = binding.value
    el.addEventListener('click', throttle(originalHandler, throttleTime))
  },
  unbind(el, binding) {
    const throttleTime = binding.arg || 300
    const originalHandler = binding.value

    el.removeEventListener('click', throttle(originalHandler, throttleTime))
  }
})

Vue.use(Popconfirm)
Vue.use(Radio)
Vue.use(Progress)
Vue.use(Upload)
Vue.use(Tooltip)
Vue.use(DatePicker)
Vue.use(Dropdown)
Vue.use(Menu)
Vue.use(Button)
Vue.use(Row)
Vue.use(Col)
Vue.use(Form)
Vue.use(Input)
Vue.use(InputNumber)
Vue.use(Checkbox)
Vue.use(Icon)
Vue.use(Modal)
Vue.use(Table)
Vue.use(Spin)
Vue.use(Tabs)
Vue.use(Select)
Vue.use(Pagination)
Vue.use(Cascader)
Vue.use(Divider)
Vue.use(Drawer)
Vue.use(Alert)
Vue.use(Tag)
Vue.use(Descriptions)
Vue.use(Empty)
// Vue.use(TimePicker)
Vue.use(FormModel)
Vue.use(Collapse)
Vue.use(Popover)
Vue.use(ConfigProvider)
Vue.use(Switch)
Vue.config.productionTip = false

const USER_KEY = 'user_key'
// 根据路由设置标题
router.beforeEach((to, from, next) => {
  store.commit('setPageInit', false)
  // console.log('beforeEach1111111111111')
  // 移动端外连接页面
  const mobilePage = [
    '/mobileAgreement',
    '/mobile-agreement',
    '/mobileAboutUs',
    '/mobile-about-us',
    '/MobileCancellation',
    '/mobile-cancellation',
    '/mobile-copyright',
    '/MobileCopyright',
    '/small-page',
    '/websocket',
    '/rtc-push',
    '/rtc-pull'
  ]
  // 不需要登录就能进去的页面
  const noNeedRoute = [
    '/login',
    '/ie-page',
    '/small-page',
    '/websocket',
    '/rtc-push',
    '/rtc-pull',
    '/cdn-resource'
  ]
  const isNoNeedLogin =
    noNeedRoute.includes(to.path) || mobilePage.includes(to.path)
  // 是否是手机浏览
  const isMobilePage = isMobile()
  if (!mobilePage.includes(to.path) && isMobilePage) {
    // lang 1 代表中文  2 代表英文  type 0 代表模型库后台ceshi
    const isPro =
      process.env.NODE_ENV === 'production' ||
      process.env.NODE_ENV === 'international'
    const type = isPro ? 1 : 0
    const toUrl = `${process.env.VUE_APP_MOBILE_URL}/mobile-page/?lang=1&type=${type}`
    // const toUrl =
    //   'http://192.168.1.169:8081/creality-cloud/mobile-page/?lang=1&type=0'
    window.location.href = toUrl
  } else {
    if (!isNoNeedLogin) {
      let storage_user = window.localStorage.getItem(USER_KEY)
      if (!storage_user) {
        store.commit('setPageFrom', to.fullPath)
        store.commit('setPageInit', true)
        return next('/login')
      }
    }
    /* 路由发生改变修改页面的title */
    if (to.meta.title) {
      document.title = to.meta.title
    }
    next()
  }
})
// 所有页面跳转后 滚动条都在最顶处
router.afterEach((to, from) => {
  store.commit('setPageInit', true)
  if (from.path === '/feedback' && to.path === '/feedback') return
  window.scrollTo(0, 0)
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
